import { z } from "zod";

export const imageEditEngineSchema = z.enum(["ideogram-v4.5", "gpt-image-2", "nano-banana-2", "flux-fill", "flux-erase", "local"]);
export type ImageEditEngine = z.infer<typeof imageEditEngineSchema>;
export type IdeogramRender = {
  proofKey: string;
  provider: "ideogram/v4.5/edit";
  quality: "very_low" | "low" | "medium" | "high";
  state: "submitting" | "submitted" | "failed";
  requestId?: string;
};
export type TextEngineState = {
  renders: Record<string, IdeogramRender>;
  ideogramFlagOn: boolean;
  fallbackOccurred: boolean;
  engine?: ImageEditEngine | "mixed";
  passes?: Array<{ engine: ImageEditEngine; tier: string }>;
};

export function summarizeTextEngines(passes: Array<{ engine: ImageEditEngine; tier: string }>) {
  const unique = new Set(passes.map((pass) => pass.engine));
  return { engine: unique.size > 1 ? "mixed" as const : passes[0]?.engine ?? "local" as const, passes };
}

export const textEngineStateSchema: z.ZodType<TextEngineState> = z.object({
  renders: z.record(z.object({
    proofKey: z.string(),
    provider: z.literal("ideogram/v4.5/edit"),
    quality: z.enum(["very_low", "low", "medium", "high"]),
    state: z.enum(["submitting", "submitted", "failed"]),
    requestId: z.string().optional(),
  })),
  ideogramFlagOn: z.boolean(),
  fallbackOccurred: z.boolean(),
  engine: z.union([imageEditEngineSchema, z.literal("mixed")]).optional(),
  passes: z.array(z.object({ engine: imageEditEngineSchema, tier: z.string() })).optional(),
});
